import { AxiosInstance } from "axios";
import ITradeBasicInfo from "src/components/Refatoracao/ITradeBasicInfo";
import IQueryTradesBasicInfo from "../interfaces/IQueryTradesBasicInfo";
import IWorkflowBasicInfo from "../interfaces/IWorkflowBasicInfo";
import { ITrade } from "../interfaces/trade/ITrade";
import { ApiService } from "../models/Api.model";

enum TradeSearchServiceEnum {
  getBasicInfo = "/basic-info",
  getTradeDetail = "/detail?",
  searchTrades = "/filter"
}

export default class TradeSearchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/search");
  }

  public getTradesBasicInfo = async (queryString: IQueryTradesBasicInfo): Promise<IWorkflowBasicInfo> => await this.POST(`${TradeSearchServiceEnum.getBasicInfo}`, queryString);
  public getTradeDetail = async (tradeId: number): Promise<ITrade> => await this.GET(TradeSearchServiceEnum.getTradeDetail + "id=" + tradeId);
  public searchTrades = async (query: string): Promise<ITradeBasicInfo[]> => await this.POST(TradeSearchServiceEnum.searchTrades, { query });
}



// WEBPACK FOOTER //
// ./src/services/api/TradeSearch.service.ts